// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1zatW","requiredAsterisk":"Info_requiredAsterisk__12BN9"};